export default "__VITE_ASSET__ClYDdjH7__"